import { render } from "./NotificationSettingsContainer.vue?vue&type=template&id=5958569c"
import script from "./NotificationSettingsContainer.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__